import React from 'react';
import StepsCarousel from '@components/StepsCarousel';
import { SectionSubtitle, SectionTitle, SectionWrapper } from '@styles';
import { TraineesHowItWorksSectionData } from './types';

const HowItWorksSection: React.FC<TraineesHowItWorksSectionData> = (props) => {
  const { how_it_works_title, how_it_works_subtitle, how_it_works_steps } = props;

  // Follow existing error handling pattern
  if (!how_it_works_title?.text || !how_it_works_subtitle?.text || !how_it_works_steps || how_it_works_steps.length === 0) {
    console.error('How it works section: Missing required Prismic data', {
      has_title: !!how_it_works_title?.text,
      title_content: how_it_works_title?.text,
      has_subtitle: !!how_it_works_subtitle?.text,
      subtitle_content: how_it_works_subtitle?.text,
      has_steps: !!how_it_works_steps,
      steps_count: how_it_works_steps?.length || 0
    });
    return null;
  }

  const placeholdersMapper = how_it_works_steps.map((step) => step.step_image.url);
  return (
    <SectionWrapper>
      <SectionTitle>{how_it_works_title.text}</SectionTitle>
      <SectionSubtitle>{how_it_works_subtitle.text}</SectionSubtitle>
      <StepsCarousel steps={how_it_works_steps} placeholdersMapper={placeholdersMapper} />
    </SectionWrapper>
  );
};

export default HowItWorksSection;
